import { render, staticRenderFns } from "./purgrndetailview.vue?vue&type=template&id=65822b02&scoped=true&"
import script from "./purgrndetailview.vue?vue&type=script&lang=js&"
export * from "./purgrndetailview.vue?vue&type=script&lang=js&"
import style0 from "./purgrndetailview.vue?vue&type=style&index=0&id=65822b02&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65822b02",
  null
  
)

export default component.exports